import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { designer } from "../mock";
import { initTickAudio, playTick } from "../lib/tick";

const nav = [
  { label: "Design", to: "/" },
  { label: "About", to: "/about" }
];

// Initialise the audio context as soon as the header mounts so that the very
// first click is ready to play without a perceptible delay.
if (typeof window !== "undefined") initTickAudio();

const onClickTick = () => playTick();

const Header = () => {
  const [open, setOpen] = useState(false);
  const [faded, setFaded] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  // On the home page (mobile only), fade the header when the user scrolls past the top.
  useEffect(() => {
    if (!isHome) {
      setFaded(false);
      return;
    }
    const onScroll = () => {
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      setFaded(isMobile && window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [isHome]);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-paper border-b border-soft transition-opacity duration-300"
      style={{ opacity: faded && !open ? 0.4 : 1 }}
    >
      <div className="max-w-[1700px] mx-auto px-10 md:px-20 h-16 md:h-20 flex items-center justify-between">
        {/* Left: name */}
        <Link to="/" onClick={onClickTick} className="serif text-xl md:text-2xl tracking-tight">
          {designer.name}
        </Link>

        {/* Right: nav + CTA */}
        <div className="hidden md:flex items-center gap-10">
          {nav.map((n) => (
            <Link
              key={n.label}
              to={n.to}
              onClick={onClickTick}
              className="text-sm tracking-wide hover-line text-ink/85 hover:text-ink"
            >
              {n.label}
            </Link>
          ))}
          <a
            href={`mailto:${designer.email}`}
            onClick={onClickTick}
            className="text-sm border border-ink px-4 py-2 rounded-sm hover:bg-ink hover:text-paper transition-colors duration-300"
          >
            Get in touch
          </a>
        </div>

        {/* Mobile menu button */}
        <button
          aria-label="Menu"
          onClick={() => { onClickTick(); setOpen(!open); }}
          className="md:hidden flex flex-col gap-1.5 p-2"
        >
          <span className={`block w-6 h-px bg-ink transition-transform ${open ? "translate-y-1.5 rotate-45" : ""}`}></span>
          <span className={`block w-6 h-px bg-ink transition-opacity ${open ? "opacity-0" : ""}`}></span>
          <span className={`block w-6 h-px bg-ink transition-transform ${open ? "-translate-y-1.5 -rotate-45" : ""}`}></span>
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-paper border-t border-soft px-10 md:px-20 py-6 space-y-4">
          {nav.map((n) => (
            <Link
              key={n.label}
              to={n.to}
              onClick={() => { onClickTick(); setOpen(false); }}
              className="block serif text-2xl"
            >
              {n.label}
            </Link>
          ))}
          <a
            href={`mailto:${designer.email}`}
            onClick={() => { onClickTick(); setOpen(false); }}
            className="inline-block mt-2 text-sm border border-ink px-4 py-2 rounded-sm"
          >
            Get in touch
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
